import { useSelector } from 'react-redux';
export default function useAppState() {
  return useSelector(state => state);
}